import { Box, Card } from '@mui/material';

import ProfileForm from '@/components/forms/profile/ProfileForm';
import useTitle from '@/hooks/useTitle';
import useAppStore from '@/store/app';
import { useEffect } from 'react';

export default function Profile() {
  useTitle('Profil');
  const { setNavigation } = useAppStore();

  useEffect(() => {
    setNavigation(null);
  }, []);

  return (
    <Box
      sx={{
        padding: '20px',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        flex: 1,
      }}
    >
      <Card
        sx={{
          padding: '20px',
          marginBottom: '20px',
          width: {
            xs: '90%',
            sm: '90%',
            md: '500px',
          },
          maxWidth: '100%',
          gap: 2,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <ProfileForm />
      </Card>
    </Box>
  );
}
